var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkleActiveMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 24,
    viewBox: "0 0 44 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 24,
    rx: 12,
    fill: "#E9F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8362 15.7102L21.3362 19.7806C21.2918 19.9002 21.2119 20.0033 21.1071 20.0762C21.0024 20.149 20.8779 20.1881 20.7503 20.1881C20.6227 20.1881 20.4982 20.149 20.3934 20.0762C20.2887 20.0033 20.2087 19.9002 20.1643 19.7806L18.6643 15.7102C18.6327 15.6243 18.5828 15.5463 18.518 15.4816C18.4533 15.4168 18.3753 15.3669 18.2893 15.3352L14.219 13.8352C14.0994 13.7908 13.9963 13.7109 13.9234 13.6062C13.8506 13.5014 13.8115 13.3769 13.8115 13.2493C13.8115 13.1217 13.8506 12.9972 13.9234 12.8924C13.9963 12.7877 14.0994 12.7078 14.219 12.6634L18.2893 11.1634C18.3753 11.1317 18.4533 11.0818 18.518 11.017C18.5828 10.9523 18.6327 10.8743 18.6643 10.7884L20.1643 6.71806C20.2087 6.59845 20.2887 6.49529 20.3934 6.42244C20.4982 6.34959 20.6227 6.31055 20.7503 6.31055C20.8779 6.31055 21.0024 6.34959 21.1071 6.42244C21.2119 6.49529 21.2918 6.59845 21.3362 6.71806L22.8362 10.7884C22.8679 10.8743 22.9178 10.9523 22.9825 11.017C23.0473 11.0818 23.1253 11.1317 23.2112 11.1634L27.2815 12.6634C27.4011 12.7078 27.5043 12.7877 27.5771 12.8924C27.65 12.9972 27.689 13.1217 27.689 13.2493C27.689 13.3769 27.65 13.5014 27.5771 13.6062C27.5043 13.7109 27.4011 13.7908 27.2815 13.8352L23.2112 15.3352C23.1253 15.3669 23.0473 15.4168 22.9825 15.4816C22.9178 15.5463 22.8679 15.6243 22.8362 15.7102Z",
    stroke: "#2B6CB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 3.25V7",
    stroke: "#2B6CB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 5.125H23.875",
    stroke: "#2B6CB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 7.625V10.125",
    stroke: "#2B6CB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 8.875H28.25",
    stroke: "#2B6CB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleActiveMobile);
export default __webpack_public_path__ + "static/media/sparkleActiveMobile.9f137fb80bd89a32f4fed46827ec8315.svg";
export { ForwardRef as ReactComponent };